import React, { useState, useEffect, useMemo } from 'react';
import { FiFilter, FiDownload } from 'react-icons/fi';
import vendorDashboardService from '../../services/vendorDashboardService';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import { customDateFormatShort } from '../../config/utils';
import { toast } from 'react-toastify';

function VendorTimeTracking() {
  const [showFilters, setShowFilters] = useState(false);
  const [datePreset, setDatePreset] = useState('');
  const [filters, setFilters] = useState({
    project_id: '',
    task_id: '',
    start_date: '',
    end_date: '',
    status: '',
    is_billable: ''
  });

  const [entries, setEntries] = useState([]);
  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1, limit: 10 });
  const [selectedIds, setSelectedIds] = useState([]);
  const [approvalData, setApprovalData] = useState({});
  const [form, setForm] = useState({
    status: "",
    comments: "",
  });
  const [openRow, setOpenRow] = useState(null);

  const toggleRow = (id) => {
    setOpenRow(openRow === id ? null : id);
  };



  // const activeRows =
  //   activeTab === 'unbilled' ? unbilledTasks :
  //     activeTab === 'draft' ? draftTasks :
  //       tabFilteredEntries;

  // const isAllSelected =
  //   activeRows.length > 0 &&
  //   activeRows.every(row => selectedIds.includes(row));

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelectedIds(activeRows.map(row => row));
  //   } else {
  //     setSelectedIds([]);
  //   }
  // };

  useEffect(() => {
    loadSubmissions()
  }, []);

  const handleSelectRow = (id) => {
    console.log("selected rows", id)
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(entryId => entryId !== id)
        : [...prev, id]
    );
    console.log("selectedIds", selectedIds)
  };

  const filteredTasks = useMemo(() => {
    if (!filters.project_id) return tasks;
    return tasks.filter(task => String(task.project_id) === String(filters.project_id));
  }, [tasks, filters.project_id]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'project_id' ? { task_id: '' } : {})
    }));
  };

  const handleDatePresetChange = (preset) => {
    setDatePreset(preset);

    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (preset) {
      case 'today':
        start = end = today;
        break;
      case 'thisWeek': {
        const day = today.getDay();
        start = new Date(today);
        start.setDate(today.getDate() - day);
        end = today;
        break;
      }
      case 'thisMonth':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = today;
        break;
      case 'last7Days':
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = today;
        break;
      case 'last30Days':
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = today;
        break;
      default:
        break;
    }

    const toISODate = (d) => d.toISOString().split('T')[0];
    setFilters(prev => ({
      ...prev,
      start_date: toISODate(start),
      end_date: toISODate(end)
    }));
  };

  const clearFilters = () => {
    setFilters({
      project_id: '',
      task_id: '',
      start_date: '',
      end_date: '',
      status: '',
      is_billable: ''
    });
    setDatePreset('');
  };

  const applyFilters = () => {
    // TODO: trigger your fetch/query with `filters` applied
    console.log('Applying filters:', filters);
  };

  const handleExport = () => {
    if (!entries || entries.length === 0) return;

    const headers = Object.keys(entries[0]);
    const csvRows = [
      headers.join(','),
      ...entries.map(row =>
        headers.map(h => JSON.stringify(row[h] ?? '')).join(',')
      )
    ];
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'time_entries.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };



  const loadSubmissions = async () => {
    try {
      setLoading(true);
      const data = await vendorDashboardService.getAllTimeTrackingApprovals(filters);
      setTasks(data.pending_entries || []);
      setPagination(data.pagination);
    } catch (err) {
      console.error('Error loading tasks:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (entry) => {
    console.log("")
    if (!form.status) {
      toast.error("Status are required");
      return;
    }

    if (
      form.status === "rejected" &&
      !form.comments.trim()
    ) {
      toast.error("Comments are mandatory when status is Rejected.");
      return;
    }

    const payload = {
      submission_id: entry.id,
      status: form.status,
      comments: form.comments,
    };


    try {
      await vendorDashboardService.submitTimetrackings(payload);
      toast.success("Submitted success")
    } catch (err) {
      toast.error(err.response?.data?.error);
    }


  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Time Tracking</h1>
          <p className="mt-1 text-sm text-gray-600">
            Track your time, manage entries, and view statistics
          </p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mt-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
          >
            <FiFilter className="mr-2" />
            {showFilters ? 'Hide Filters' : 'Show Filters'}
          </button>

          <button
            onClick={handleExport}
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!entries || entries.length === 0}
          >
            <FiDownload className="mr-2" />
            Export CSV
          </button>
        </div>

        {/* Filters Panel */}
        {showFilters && (
          <div className="mt-4 pt-4 border-t space-y-4">
            {/* Date Presets */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Quick Date Range
              </label>
              <div className="flex flex-wrap gap-2">
                {['today', 'thisWeek', 'thisMonth', 'last7Days', 'last30Days'].map(preset => (
                  <button
                    key={preset}
                    onClick={() => handleDatePresetChange(preset)}
                    className={`px-3 py-1 rounded-lg text-sm transition ${datePreset === preset
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                  >
                    {preset.replace(/([A-Z])/g, ' $1').trim()}
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Project
                </label>
                <select
                  name="project_id"
                  value={filters.project_id}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">All Projects</option>
                  {projects?.map(project => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Task
                </label>
                <select
                  name="task_id"
                  value={filters.task_id}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={!filters.project_id}
                >
                  <option value="">All Tasks</option>
                  {filteredTasks.map(task => (
                    <option key={task.id} value={task.id}>
                      {task.title}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Status
                </label>
                <select
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">All Statuses</option>
                  <option value="draft">Draft</option>
                  <option value="submitted">Submitted</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Start Date
                </label>
                <input
                  type="date"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  End Date
                </label>
                <input
                  type="date"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Billable
                </label>
                <select
                  name="is_billable"
                  value={filters.is_billable}
                  onChange={handleFilterChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">All</option>
                  <option value="true">Billable Only</option>
                  <option value="false">Non-Billable Only</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={clearFilters}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
              >
                Clear Filters
              </button>
              <button
                onClick={applyFilters}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Apply Filters
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow border border-gray-200 mt-5">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-10">
                {/* <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                /> */}
              </th>

              <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                Code
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                Submitted on
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                Comments
              </th>

              <th className="px-6 py-3 text-left text-xs font-semibold uppercase">

              </th>
              <th className="w-12"></th>
            </tr>
          </thead>

          <tbody>
            {tasks.map((project) => (
              <>
                {/* Main Row */}
                <tr
                  key={project.id}
                  className={`border-t hover:bg-gray-50 cursor-pointer ${selectedIds.includes(project) ? "bg-blue-50" : ""
                    }`}
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(project)}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleSelectRow(project);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </td>

                  <td
                    className="px-6 py-4 font-medium cursor-pointer"
                    onClick={() => toggleRow(project.id)}
                  >
                    {project.submission_code}
                  </td>

                  <td onClick={() => toggleRow(project.id)}>
                    {customDateFormatShort(project.submitted_date)}
                  </td>

                  <td onClick={() => toggleRow(project.id)}>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800`}>{project.status === 'submitted' ? 'Approval pending' : `${project.status}`}</span>
                  </td>

                  <td onClick={() => toggleRow(project.id)}>
                    {project.comments || "-"}
                  </td>

                  <td
                    className="px-4 cursor-pointer"
                    onClick={() => toggleRow(project.id)}
                  >
                    {openRow === project.id ? (
                      <FaChevronUp size={18} />
                    ) : (
                      <FaChevronDown size={18} />
                    )}
                  </td>
                </tr>

                {/* Accordion Row */}
                {openRow === project.id && (
                  <tr>
                    <td colSpan={5} className="bg-gray-50 p-4">
                      <div className="grid grid-cols-12 gap-6">

                        {/* Left Section (8 Columns) */}
                        <div className="col-span-8 overflow-x-auto">
                          {(() => {
                            const totalHours = project?.submission_time_entries?.reduce(
                              (sum, entry) => sum + (Number(entry?.hours_spent) || 0),
                              0
                            );

                            const totalAmount = project?.submission_time_entries?.reduce(
                              (sum, entry) =>
                                sum +
                                (Number(entry?.hours_spent || 0) *
                                  Number(entry?.hourly_rate || 0)),
                              0
                            );

                            const totalDuration = project?.submission_time_entries?.reduce(
                              (sum, entry) => sum + (Number(entry?.duration) || 0),
                              0
                            );

                            const totalRate = project?.submission_time_entries?.reduce(
                              (sum, entry) => sum + (Number(entry?.hourly_rate) || 0),
                              0
                            );

                            return (
                              <table className="min-w-full border border-gray-200 rounded-lg">
                                <thead className="bg-gray-100">
                                  <tr>
                                    <th className="px-4 py-2 border text-left">Code</th>
                                    <th className="px-4 py-2 border text-left">Task</th>
                                    <th className="px-4 py-2 border text-left">Hours</th>
                                    <th className="px-4 py-2 border text-left">Duration</th>
                                    <th className="px-4 py-2 border text-left">Rate</th>
                                    <th className="px-4 py-2 border text-left">Amount</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {project?.submission_time_entries?.map((entry) => {
                                    const amount =
                                      (Number(entry?.hours_spent) || 0) *
                                      (Number(entry?.hourly_rate) || 0);

                                    return (
                                      <tr key={entry.id}>
                                        <td className="px-4 py-2 border">
                                          {entry?.task?.task_code || "-"}
                                        </td>

                                        <td className="px-4 py-2 border">
                                          {entry?.task?.title || "-"}
                                        </td>
                                        <td className="px-4 py-2 border">
                                          {entry?.hours_spent || "-"}
                                        </td>
                                        <td className="px-4 py-2 border">
                                          {entry?.duration || "-"}
                                        </td>
                                        <td className="px-4 py-2 border">
                                          {entry?.hourly_rate || "-"}
                                        </td>
                                        <td className="px-4 py-2 border">
                                          {amount.toFixed(2)}
                                        </td>
                                      </tr>
                                    );
                                  })}

                                  <tr className="bg-gray-100 font-semibold">
                                    <td className="px-4 py-2 border text-right" colSpan='2'>Total</td>
                                    <td className="px-4 py-2 border">
                                      {totalHours.toFixed(2)}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      {totalDuration.toFixed(2)}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      {totalRate.toFixed(2)}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      {totalAmount.toFixed(2)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })()}
                        </div>

                        {/* Right Section (4 Columns) */}
                        <div className="col-span-4">
                          <div className="bg-white border rounded-lg shadow-sm p-5 space-y-5">

                            <h3 className="text-lg font-semibold border-b pb-2">
                              Approval Details
                            </h3>
                            {/* Comments */}
                            <div>

                              <textarea
                                name="comments"
                                rows={6}
                                value={form.comments}
                                onChange={handleChange}
                                placeholder="Enter your comments..."
                                className="w-full border rounded-md px-3 py-2 resize-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            {/* Status */}
                            <div>

                              <select
                                name="status"
                                value={form.status}
                                onChange={handleChange}
                                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500"
                              >
                                <option value="">Status</option>
                                <option value="approved">Approve</option>
                                <option value="rejected">Rejected</option>
                                <option value="clarification">Need Clarification</option>
                              </select>
                            </div>

                            <button
                              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md font-medium transition"
                              onClick={() => handleSubmit(project)}
                            >
                              Submit
                            </button>

                          </div>
                        </div>

                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default VendorTimeTracking;